import script from "./IconBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconBtn.vue?vue&type=script&lang=ts&setup=true"

import "./IconBtn.vue?vue&type=style&index=0&id=1996db5c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1996db5c"]])

export default __exports__